interface CompanyLogo {
  name: string;
  logoUrl: string;
}

export const COMPANY_LOGOS: CompanyLogo[] = [
  {
    name: 'BIM 3D',
    logoUrl:
      'https://cdn.prod.website-files.com/66c3b1689112111109d136c9/68e5ada0a5aa1061881669a4_BIM_3D_Logo%201.avif',
  },
  {
    name: 'Seventh Sense Projects',
    logoUrl:
      'https://cdn.prod.website-files.com/66c3b1689112111109d136c9/68e5ad7d1146e9d4c8b77109_bf982c_3991a0d1d92d46c98e3743a42a45a1e5~mv2%201.avif',
  },
  {
    name: 'Agricon',
    logoUrl:
      'https://cdn.prod.website-files.com/66c3b1689112111109d136c9/68e5ad60cd40ae3977f2549d_Agricon_logo%201.avif',
  },
  {
    name: 'Agile Tech Now',
    logoUrl:
      'https://cdn.prod.website-files.com/66c3b1689112111109d136c9/68e5ad44016629fcf6d04cc2_Agile_Tech_Now_Logo%201.avif',
  },
  {
    name: 'Austbrokers',
    logoUrl:
      'https://cdn.prod.website-files.com/66c3b1689112111109d136c9/68e5ad25ffcfdded0bbe4cf4_abcomsure-logo%201.avif',
  },
  {
    name: '9 Pros',
    logoUrl:
      'https://cdn.prod.website-files.com/66c3b1689112111109d136c9/68e5ad0e91436ecdd1fbf0fc_9_Pros_Logo%201.avif',
  },
  {
    name: '3 Cloud',
    logoUrl:
      'https://cdn.prod.website-files.com/66c3b1689112111109d136c9/68e5acf34ba2d7090c1ce3f7_3Cloud_logo-light%201.avif',
  },
  {
    name: '3G Productions',
    logoUrl:
      'https://cdn.prod.website-files.com/66c3b1689112111109d136c9/68e5acdea4f013fb68e29f6e_3G_Productions_Logo%201.avif',
  },
  {
    name: 'Honolulu Gov',
    logoUrl:
      'https://cdn.prod.website-files.com/66c3b1689112111109d136c9/68e59052594321b9f65e89e9_Honolulu_GOV_Logo.avif',
  },
  {
    name: 'Tulane University',
    logoUrl:
      'https://cdn.prod.website-files.com/66c3b1689112111109d136c9/68e5903a84294e760e6003d7_Tulane_University_Logo.avif',
  },
  {
    name: 'Queensland Gov',
    logoUrl:
      'https://cdn.prod.website-files.com/66c3b1689112111109d136c9/68e5901432a4a265f87061df_header-logo-qgov-dark.avif',
  },
  {
    name: 'Veenion',
    logoUrl:
      'https://cdn.prod.website-files.com/66c3b1689112111109d136c9/68e5ac192944409f4eee9518_veenion_logo%201.avif',
  },
  {
    name: 'Tyson Mendes',
    logoUrl:
      'https://cdn.prod.website-files.com/66c3b1689112111109d136c9/68e5abee059d47887b30b690_Tyson_Mendes_Logo%201.avif',
  },
  {
    name: 'Prova Work',
    logoUrl:
      'https://cdn.prod.website-files.com/66c3b1689112111109d136c9/68e5ab838db817ca06f934a5_provawork_logo_transparent%201.avif',
  },
  {
    name: 'Pearce IT',
    logoUrl:
      'https://cdn.prod.website-files.com/66c3b1689112111109d136c9/68e59acd70731d41488f2e07_Pearce_IT_Logo%201.avif',
  },
  {
    name: 'Foundation Security',
    logoUrl:
      'https://cdn.prod.website-files.com/66c3b1689112111109d136c9/68e5aefd8c7ac28145acb557_Foundation_Security_Logo%201.avif',
  },
  {
    name: 'Lake Cable',
    logoUrl:
      'https://cdn.prod.website-files.com/66c3b1689112111109d136c9/68e5afdd37ce7bd7ba8b6040_lake-cable-dark-transparent_Logo%201.avif',
  },
  {
    name: 'Blue Tiger',
    logoUrl:
      'https://cdn.prod.website-files.com/66c3b1689112111109d136c9/68e5ae83f661dca4c9792252_bluetiger-new_color.png%201.avif',
  },
  {
    name: 'Healthyr',
    logoUrl:
      'https://cdn.prod.website-files.com/66c3b1689112111109d136c9/68e598c0a510d00d7196c4fa_Healthyr_Logo%201.avif',
  },
  {
    name: 'AXYS',
    logoUrl:
      'https://cdn.prod.website-files.com/66c3b1689112111109d136c9/68e5983380917d32e9255f23_AXYS-logo-color%201.avif',
  },
];
